import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const BRANDS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('BRANDS');
export const BRANDS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	BRANDS_CRUD_ACTION_CONSTANTS
);
